// The four destinations, and the rail around them.
export const nav = {
  // ── nav / chrome ─────────────────────────────────────────────────────
  'nav.brand.name': 'Parsina',
  'nav.brand.panel': 'Student & resident panel',
  'nav.items.patients': 'Patients',
  'nav.items.chat': 'Chat',
  'nav.items.credits': 'Parseh',
  'nav.items.profile': 'Profile',
  'nav.sidebar.collapse': 'Collapse menu',
  'nav.sidebar.expand': 'Expand menu',
  'nav.sidebar.logout': 'Sign out',
  'nav.sidebar.editProfile': 'Profile',
  'nav.sidebar.shortcuts': 'Keyboard shortcuts',
  'nav.balance.label': 'Balance',
  'nav.landmark.primary': 'Main menu',
  'nav.landmark.content': 'Content',
};

export default nav;
